import React from "react";
import tw from "tailwind-styled-components";
import { FaRupeeSign, FaCheckCircle, FaClock, FaExclamationTriangle } from "react-icons/fa";
import { MdOutlineChevronRight, MdPayment } from "react-icons/md";
import { GiMoneyStack } from "react-icons/gi";

const CommissionSummaryCards = ({ summaryData, onClick, setSelectedId, selectedId }) => {

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount).replace('₹', '');
    };

    const summary = [
        {
            amount: summaryData?.total ? `₹${formatCurrency(summaryData.total)}` : '₹0',
            label: `Total Commission`,
            icon: <GiMoneyStack size={20} />,
            filter: 'total',
            color: "text-blue-600",
            bgColor: "bg-blue-50",
        },
        {
            amount: summaryData?.recieved ? `₹${formatCurrency(summaryData.recieved)}` : '₹0',
            label: `Received`,
            icon: <FaCheckCircle size={20} />,
            filter: 'Received',
            color: "text-green-600",
            bgColor: "bg-green-50",
        },
        {
            amount: summaryData?.pending ? `₹${formatCurrency(summaryData.pending)}` : '₹0',
            label: `Pending`,
            icon: <FaClock size={20} />,
            filter: 'Pending',
            color: "text-yellow-600",
            bgColor: "bg-yellow-50",
        },
        {
            amount: summaryData?.overDue ? `₹${formatCurrency(summaryData.overDue)}` : '₹0',
            label: `Overdue`,
            icon: <FaExclamationTriangle size={20} />,
            filter: 'Overdue',
            color: "text-red-600",
            bgColor: "bg-red-50",
        },
    ];

    return (
        <Wrapper>
            <ScrollCard style={{
                scrollBehavior: "smooth",
            }}>
                {summary.map((item, index) => (
                    <Card
                        $selected={selectedId === index}
                        key={index}
                    >


                        <ValueRow>
                            <Value $color={item.color}>{item.amount}</Value>
                        </ValueRow>
                        <Label>
                            {item.label}

                        </Label>

                    </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
};

const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;


const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-2xl font-semibold text-gray-900
`;

const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;
export default CommissionSummaryCards;